/**
 * @generated SignedSource<<1c3cd6f2e90d2e63aafd382d7068c152>>
 * @relayHash 7c3af731904cf29f069946820fa6872a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7a5b7aaf2cc86caed2af30b08f381d8a6da83c2522a9ffa729475633a0c27306

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type JiraIssueSearchFieldSetsInput = {
  fieldSetIds?: ReadonlyArray<string> | null | undefined;
  viewInput?: JiraIssueSearchViewInput | null | undefined;
};
export type JiraIssueSearchViewInput = {
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  filterId?: string | null | undefined;
  namespace?: string | null | undefined;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsContext = {
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type ui_main_ConfigurableChildIssuesPanelQuery$variables = {
  after?: string | null | undefined;
  amountOfColumns: number;
  before?: string | null | undefined;
  cloudId: string;
  fieldSetIds: ReadonlyArray<string>;
  fieldSetsContext?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  fieldSetsInput?: JiraIssueSearchFieldSetsInput | null | undefined;
  filterId?: string | null | undefined;
  first?: number | null | undefined;
  issueKey: string;
  issueSearchInput: JiraIssueSearchInput;
  last?: number | null | undefined;
  namespace?: string | null | undefined;
  shouldQueryFieldSetsById: boolean;
  viewId?: string | null | undefined;
};
export type ui_main_ConfigurableChildIssuesPanelQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_data">;
};
export type ui_main_ConfigurableChildIssuesPanelQuery = {
  response: ui_main_ConfigurableChildIssuesPanelQuery$data;
  variables: ui_main_ConfigurableChildIssuesPanelQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchinm2performanceisissuesearchapienabledrelayprovider": isIssueSearchAPIEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": isRealtimeUpdateEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider": isCheckIssueCreatePermissionsEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": isJscInfiniteScrollEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": isJscM2Enabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": isMultiGroupPickerCellEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": isJscInlineEditFlagFixEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": isRenderJiraWatchesFieldNINEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchinm2performanceisissuesearchapienabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider: {
    readonly get: () => boolean;
  };
});

import isJscIFCEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-ifc-enabled.relayprovider';
import isJscInfiniteScrollEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-infinite-scroll-enabled.relayprovider';
import isRenderJiraWatchesFieldNINEnabled_provider from '@atlassian/jira-relay-provider/src/is-render-jirawatchesfield-nin.relayprovider';
import isRealtimeUpdateEnabled_provider from '@atlassian/jira-relay-provider/src/jira-issue-view-child-issues-panel-realtime-update.relayprovider';
import isIssueSearchAPIEnabled_provider from '@atlassian/jira-relay-provider/src/jira-issue-view-chin-m2-performance-isissuesearchapienabled.relayprovider';
import isCheckIssueCreatePermissionsEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-check-issue-create-permissions.relayprovider';
import isReparentingEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-reparenting.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import isJscInlineEditRefactorEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-field-refactor.relayprovider';
import isJscInlineEditFlagFixEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-flag-fix.relayprovider';
import isJscM2Enabled_provider from '@atlassian/jira-relay-provider/src/jsc-m2-fe-changes.relayprovider';
import isJscMergedColumnEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-merged-column.relayprovider';
import isMultiGroupPickerCellEnabled_provider from '@atlassian/jira-relay-provider/src/nin-multi-group-picker-cell.relayprovider';
import includeSingleSelectColorField_provider from '@atlassian/jira-relay-provider/src/thor-colorful-single-select-milestone2-experiment.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amountOfColumns"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetIds"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsContext"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsInput"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "namespace"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryFieldSetsById"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v15 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v16 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v17 = {
  "kind": "ScalarField",
  "name": "id"
},
v18 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "amountOfColumns"
},
v19 = {
  "kind": "ScalarField",
  "name": "fieldSetId"
},
v20 = {
  "kind": "ScalarField",
  "name": "type"
},
v21 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v22 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v23 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v24 = {
  "kind": "ScalarField",
  "name": "__id"
},
v25 = {
  "kind": "ClientExtension",
  "selections": [
    (v24/*: any*/)
  ]
},
v26 = [
  (v17/*: any*/)
],
v27 = [
  {
    "kind": "ScalarField",
    "name": "canPerform"
  }
],
v28 = {
  "kind": "ScalarField",
  "name": "key"
},
v29 = {
  "kind": "Variable",
  "name": "fieldSetsInput",
  "variableName": "fieldSetsInput"
},
v30 = {
  "kind": "Variable",
  "name": "issueSearchInput",
  "variableName": "issueSearchInput"
},
v31 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  (v15/*: any*/),
  (v29/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v30/*: any*/),
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  }
],
v32 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v33 = {
  "kind": "ScalarField",
  "name": "isResolved"
},
v34 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v35 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v34/*: any*/),
    (v17/*: any*/)
  ]
},
v36 = {
  "kind": "InlineFragment",
  "selections": [
    (v22/*: any*/),
    {
      "concreteType": "JiraStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        (v35/*: any*/),
        (v17/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusField"
},
v37 = {
  "args": [
    {
      "kind": "Literal",
      "name": "ids",
      "value": [
        "status"
      ]
    }
  ],
  "concreteType": "JiraIssueFieldConnection",
  "kind": "LinkedField",
  "name": "fieldsById",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueFieldEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v16/*: any*/),
            (v36/*: any*/),
            (v17/*: any*/)
          ]
        }
      ]
    }
  ],
  "storageKey": "fieldsById(ids:[\"status\"])"
},
v38 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v39 = {
  "concreteType": "JiraIssueTypeField",
  "kind": "LinkedField",
  "name": "issueTypeField",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v38/*: any*/),
        (v17/*: any*/)
      ]
    },
    (v17/*: any*/)
  ]
},
v40 = {
  "kind": "ClientExtension",
  "selections": [
    (v24/*: any*/),
    {
      "kind": "ScalarField",
      "name": "isHighlightedIssueRow"
    }
  ]
},
v41 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isJiraIssueField"
},
v42 = {
  "kind": "ScalarField",
  "name": "name"
},
v43 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraAffectedServiceConnection",
      "kind": "LinkedField",
      "name": "selectedAffectedServicesConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraAffectedServiceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraAffectedService",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "serviceId"
                },
                (v42/*: any*/),
                (v17/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraAffectedServicesField"
},
v44 = {
  "kind": "ScalarField",
  "name": "value"
},
v45 = [
  (v44/*: any*/),
  (v17/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v46 = {
  "kind": "ScalarField",
  "name": "lazyIsEditableInIssueView"
},
v47 = {
  "kind": "ClientExtension",
  "selections": [
    (v46/*: any*/)
  ]
},
v48 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v49 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v50 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v51 = {
  "kind": "ScalarField",
  "name": "dateTime"
},
v52 = {
  "kind": "ScalarField",
  "name": "text"
},
v53 = {
  "kind": "InlineFragment",
  "selections": [
    (v52/*: any*/),
    (v42/*: any*/),
    (v47/*: any*/)
  ],
  "type": "JiraSingleLineTextField"
},
v54 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "colorKey"
    },
    (v17/*: any*/)
  ]
},
v55 = [
  (v54/*: any*/)
],
v56 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v57 = {
  "concreteType": "JiraOption",
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v44/*: any*/)
  ]
},
v58 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v59 = {
  "kind": "ScalarField",
  "name": "picture"
},
v60 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v61 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v42/*: any*/),
        {
          "concreteType": "JiraCascadingOption",
          "kind": "LinkedField",
          "name": "cascadingOption",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraOption",
              "kind": "LinkedField",
              "name": "parentOptionValue",
              "plural": false,
              "selections": (v45/*: any*/)
            },
            {
              "concreteType": "JiraOption",
              "kind": "LinkedField",
              "name": "childOptionValue",
              "plural": false,
              "selections": (v45/*: any*/)
            }
          ]
        },
        (v47/*: any*/)
      ],
      "type": "JiraCascadingSelectField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v42/*: any*/),
        {
          "args": (v48/*: any*/),
          "concreteType": "JiraComponentConnection",
          "kind": "LinkedField",
          "name": "selectedComponentsConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraComponentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraComponent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v49/*: any*/),
                    (v50/*: any*/),
                    (v17/*: any*/)
                  ]
                }
              ]
            }
          ],
          "storageKey": "selectedComponentsConnection(first:1000)"
        },
        (v47/*: any*/)
      ],
      "type": "JiraComponentsField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v51/*: any*/),
        (v42/*: any*/),
        (v47/*: any*/)
      ],
      "type": "JiraDateTimePickerField"
    },
    (v53/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraCommentSummary",
          "kind": "LinkedField",
          "name": "commentSummary",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "canAddComment"
            },
            (v23/*: any*/)
          ]
        }
      ],
      "type": "JiraCommentSummaryField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v42/*: any*/),
        {
          "kind": "ScalarField",
          "name": "uri"
        },
        (v47/*: any*/)
      ],
      "type": "JiraUrlField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v42/*: any*/),
        {
          "concreteType": "JiraOptionConnection",
          "kind": "LinkedField",
          "name": "fieldOptions",
          "plural": false,
          "selections": [
            (v23/*: any*/)
          ]
        },
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "fieldOption",
          "plural": false,
          "selections": [
            (v44/*: any*/),
            {
              "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": (v55/*: any*/)
            },
            {
              "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": (v55/*: any*/)
            },
            (v17/*: any*/),
            (v56/*: any*/)
          ]
        },
        (v47/*: any*/)
      ],
      "type": "JiraSingleSelectField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v42/*: any*/),
        {
          "concreteType": "JiraOptionConnection",
          "kind": "LinkedField",
          "name": "selectedOptions",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraOptionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraOption",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v17/*: any*/),
                    (v44/*: any*/),
                    (v56/*: any*/)
                  ]
                }
              ]
            }
          ]
        },
        (v47/*: any*/)
      ],
      "type": "JiraMultipleSelectField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v42/*: any*/),
        {
          "concreteType": "JiraOptionConnection",
          "kind": "LinkedField",
          "name": "selectedOptions",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraOptionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                (v57/*: any*/)
              ]
            }
          ]
        },
        (v47/*: any*/)
      ],
      "type": "JiraCheckboxesField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v42/*: any*/),
        {
          "concreteType": "JiraUserConnection",
          "kind": "LinkedField",
          "name": "selectedUsersConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraUserEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v16/*: any*/),
                    (v58/*: any*/),
                    (v42/*: any*/),
                    (v59/*: any*/),
                    (v17/*: any*/),
                    (v60/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "email"
                        }
                      ],
                      "type": "AtlassianAccountUser"
                    }
                  ]
                }
              ]
            }
          ]
        },
        (v47/*: any*/)
      ],
      "type": "JiraMultipleSelectUserPickerField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v42/*: any*/),
        {
          "concreteType": "JiraTeamView",
          "kind": "LinkedField",
          "name": "selectedTeam",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "jiraSuppliedId"
            },
            {
              "kind": "ScalarField",
              "name": "jiraSuppliedName"
            }
          ]
        },
        (v47/*: any*/)
      ],
      "type": "JiraTeamViewField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "issue",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraTimeTrackingField",
              "kind": "LinkedField",
              "name": "timeTrackingField",
              "plural": false,
              "selections": [
                (v17/*: any*/),
                {
                  "concreteType": "JiraEstimate",
                  "kind": "LinkedField",
                  "name": "originalEstimate",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "timeInSeconds"
                    }
                  ]
                },
                {
                  "concreteType": "JiraTimeTrackingSettings",
                  "kind": "LinkedField",
                  "name": "timeTrackingSettings",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "workingHoursPerDay"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "workingDaysPerWeek"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "defaultFormat"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "defaultUnit"
                    }
                  ]
                },
                (v22/*: any*/),
                (v42/*: any*/),
                (v20/*: any*/),
                (v47/*: any*/)
              ]
            },
            (v17/*: any*/)
          ]
        }
      ],
      "type": "JiraOriginalTimeEstimateField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v42/*: any*/),
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "selectedOption",
          "plural": false,
          "selections": [
            {
              "alias": "label",
              "kind": "ScalarField",
              "name": "value"
            },
            (v17/*: any*/),
            (v49/*: any*/)
          ]
        },
        (v47/*: any*/)
      ],
      "type": "JiraRadioSelectField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v42/*: any*/),
        {
          "args": (v48/*: any*/),
          "concreteType": "JiraVersionConnection",
          "kind": "LinkedField",
          "name": "selectedVersionsConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraVersionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraVersion",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v17/*: any*/),
                    (v42/*: any*/),
                    (v49/*: any*/),
                    (v50/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "versionId"
                    }
                  ]
                }
              ]
            }
          ],
          "storageKey": "selectedVersionsConnection(first:1000)"
        },
        (v47/*: any*/)
      ],
      "type": "JiraMultipleVersionPickerField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v42/*: any*/),
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "issue",
          "plural": false,
          "selections": (v26/*: any*/)
        },
        {
          "args": (v48/*: any*/),
          "concreteType": "JiraGoalConnection",
          "kind": "LinkedField",
          "name": "selectedGoals",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraGoalEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraGoal",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v17/*: any*/),
                    (v28/*: any*/)
                  ]
                }
              ]
            },
            (v25/*: any*/)
          ],
          "storageKey": "selectedGoals(first:1000)"
        },
        {
          "kind": "ClientExtension",
          "selections": [
            (v24/*: any*/),
            (v46/*: any*/)
          ]
        }
      ],
      "type": "JiraGoalsField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v42/*: any*/),
        {
          "args": (v48/*: any*/),
          "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
          "kind": "LinkedField",
          "name": "confluenceRemoteIssueLinks",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraConfluenceRemoteIssueLink",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v17/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "href"
                    }
                  ]
                }
              ]
            },
            (v23/*: any*/)
          ],
          "storageKey": "confluenceRemoteIssueLinks(first:1000)"
        },
        (v47/*: any*/)
      ],
      "type": "JiraConfluenceRemoteIssueLinksField"
    }
  ]
},
v62 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraCmdbObjectConnection",
      "kind": "LinkedField",
      "name": "selectedCmdbObjectsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraCmdbObjectEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraCmdbObject",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "objectId"
                },
                {
                  "kind": "ScalarField",
                  "name": "label"
                },
                {
                  "concreteType": "JiraCmdbAvatar",
                  "kind": "LinkedField",
                  "name": "avatar",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraCmdbMediaClientConfig",
                      "kind": "LinkedField",
                      "name": "mediaClientConfig",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "clientId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "fileId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "mediaBaseUrl"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "mediaJwtToken"
                        }
                      ]
                    },
                    {
                      "kind": "ScalarField",
                      "name": "url48"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "concreteType": "QueryError",
          "kind": "LinkedField",
          "name": "errors",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "message"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraCMDBField"
},
v63 = [
  (v42/*: any*/),
  (v17/*: any*/)
],
v64 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "componentsOld",
          "concreteType": "JiraComponentConnection",
          "kind": "LinkedField",
          "name": "selectedComponentsConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraComponentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraComponent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v63/*: any*/)
                }
              ]
            }
          ]
        }
      ],
      "type": "JiraComponentsField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v52/*: any*/)
      ],
      "type": "JiraSingleLineTextField"
    }
  ]
},
v65 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v66 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "date"
    },
    (v42/*: any*/),
    (v65/*: any*/),
    (v47/*: any*/)
  ],
  "type": "JiraDatePickerField"
},
v67 = {
  "kind": "InlineFragment",
  "selections": [
    (v51/*: any*/)
  ],
  "type": "JiraDateTimePickerField"
},
v68 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraEpic",
      "kind": "LinkedField",
      "name": "epic",
      "plural": false,
      "selections": [
        (v28/*: any*/),
        {
          "kind": "ScalarField",
          "name": "summary"
        },
        {
          "kind": "ScalarField",
          "name": "color"
        },
        (v17/*: any*/)
      ]
    }
  ],
  "type": "JiraEpicLinkField"
},
v69 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "renderedFieldHtml"
    }
  ],
  "type": "JiraFallbackField"
},
v70 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatusCategory",
      "kind": "LinkedField",
      "name": "statusCategory",
      "plural": false,
      "selections": [
        (v42/*: any*/),
        (v34/*: any*/),
        (v17/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusCategoryField"
},
v71 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        (v42/*: any*/),
        {
          "kind": "ScalarField",
          "name": "statusId"
        },
        (v35/*: any*/),
        (v17/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusField"
},
v72 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": (v48/*: any*/),
      "concreteType": "JiraLabelConnection",
      "kind": "LinkedField",
      "name": "selectedLabelsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraLabelEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraLabel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v42/*: any*/)
              ]
            }
          ]
        },
        (v23/*: any*/)
      ],
      "storageKey": "selectedLabelsConnection(first:1000)"
    },
    (v42/*: any*/),
    (v47/*: any*/)
  ],
  "type": "JiraLabelsField"
},
v73 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "small"
            }
          ]
        },
        (v42/*: any*/),
        (v17/*: any*/)
      ]
    }
  ],
  "type": "JiraIssueTypeField"
},
v74 = {
  "concreteType": "JiraSingleLineTextField",
  "kind": "LinkedField",
  "name": "summaryField",
  "plural": false,
  "selections": [
    (v52/*: any*/),
    (v17/*: any*/)
  ]
},
v75 = {
  "concreteType": "JiraColorField",
  "kind": "LinkedField",
  "name": "issueColorField",
  "plural": false,
  "selections": [
    (v54/*: any*/),
    (v17/*: any*/)
  ]
},
v76 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v77 = {
  "concreteType": "JiraIssueTypeField",
  "kind": "LinkedField",
  "name": "issueTypeField",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v76/*: any*/),
        (v42/*: any*/),
        (v17/*: any*/)
      ]
    },
    (v17/*: any*/)
  ]
},
v78 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v79 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "parentIssue",
      "plural": false,
      "selections": [
        (v28/*: any*/),
        (v74/*: any*/),
        (v17/*: any*/)
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "parentIssue",
          "plural": false,
          "selections": [
            (v28/*: any*/),
            (v75/*: any*/),
            (v77/*: any*/),
            (v74/*: any*/),
            (v17/*: any*/)
          ]
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "parentIssue",
          "plural": false,
          "selections": [
            (v28/*: any*/),
            (v75/*: any*/),
            (v77/*: any*/),
            (v74/*: any*/),
            (v17/*: any*/),
            (v32/*: any*/),
            (v78/*: any*/),
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "ids",
                  "value": [
                    "summary",
                    "issuetype",
                    "status"
                  ]
                }
              ],
              "concreteType": "JiraIssueFieldConnection",
              "kind": "LinkedField",
              "name": "fieldsById",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v16/*: any*/),
                        (v17/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v22/*: any*/),
                            (v52/*: any*/)
                          ],
                          "type": "JiraSingleLineTextField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v22/*: any*/),
                            {
                              "concreteType": "JiraIssueType",
                              "kind": "LinkedField",
                              "name": "issueType",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "issueTypeId"
                                },
                                (v42/*: any*/),
                                (v76/*: any*/),
                                (v38/*: any*/),
                                (v17/*: any*/)
                              ]
                            }
                          ],
                          "type": "JiraIssueTypeField"
                        },
                        (v36/*: any*/)
                      ]
                    }
                  ]
                }
              ],
              "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
            }
          ]
        },
        (v42/*: any*/),
        (v47/*: any*/)
      ]
    }
  ],
  "type": "JiraParentIssueField"
},
v80 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        (v42/*: any*/),
        {
          "kind": "ScalarField",
          "name": "iconUrl"
        },
        (v17/*: any*/)
      ]
    },
    (v42/*: any*/),
    (v47/*: any*/)
  ],
  "type": "JiraPriorityField"
},
v81 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v42/*: any*/),
        (v28/*: any*/),
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "large"
            }
          ]
        },
        (v17/*: any*/)
      ]
    }
  ],
  "type": "JiraProjectField"
},
v82 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraResolution",
      "kind": "LinkedField",
      "name": "resolution",
      "plural": false,
      "selections": (v63/*: any*/)
    }
  ],
  "type": "JiraResolutionField"
},
v83 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraSprintConnection",
      "kind": "LinkedField",
      "name": "selectedSprintsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraSprintEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraSprint",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v17/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "sprintId"
                },
                (v42/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "state"
                },
                {
                  "kind": "ScalarField",
                  "name": "endDate"
                }
              ]
            }
          ]
        }
      ]
    },
    (v42/*: any*/),
    (v47/*: any*/)
  ],
  "type": "JiraSprintField"
},
v84 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v16/*: any*/),
        (v58/*: any*/),
        (v59/*: any*/),
        (v42/*: any*/),
        (v17/*: any*/),
        (v60/*: any*/)
      ]
    },
    (v42/*: any*/),
    (v65/*: any*/),
    (v47/*: any*/)
  ],
  "type": "JiraSingleSelectUserPickerField"
},
v85 = {
  "kind": "InlineFragment",
  "selections": [
    (v42/*: any*/),
    {
      "args": (v48/*: any*/),
      "concreteType": "JiraVersionConnection",
      "kind": "LinkedField",
      "name": "selectedVersionsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraVersionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraVersion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v63/*: any*/)
            }
          ]
        }
      ],
      "storageKey": "selectedVersionsConnection(first:1000)"
    }
  ],
  "type": "JiraMultipleVersionPickerField"
},
v86 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraRichText",
      "kind": "LinkedField",
      "name": "richText",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraADF",
          "kind": "LinkedField",
          "name": "adfValue",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraAdfToConvertedPlainText",
              "kind": "LinkedField",
              "name": "convertedPlainText",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "plainText"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraRichTextField"
},
v87 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraServiceManagementRequestType",
      "kind": "LinkedField",
      "name": "requestType",
      "plural": false,
      "selections": [
        (v42/*: any*/),
        (v76/*: any*/),
        (v17/*: any*/)
      ]
    }
  ],
  "type": "JiraServiceManagementRequestTypeField"
},
v88 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "JiraIssueLinkConnection",
      "kind": "LinkedField",
      "name": "issueLinkConnection",
      "plural": false,
      "selections": [
        (v23/*: any*/),
        {
          "concreteType": "JiraIssueLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssue",
                  "kind": "LinkedField",
                  "name": "issue",
                  "plural": false,
                  "selections": [
                    (v78/*: any*/),
                    (v28/*: any*/),
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "ids",
                          "value": [
                            "statusCategory"
                          ]
                        }
                      ],
                      "concreteType": "JiraIssueFieldConnection",
                      "kind": "LinkedField",
                      "name": "fieldsById",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueFieldEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v16/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    (v35/*: any*/)
                                  ],
                                  "type": "JiraStatusCategoryField"
                                },
                                (v17/*: any*/)
                              ]
                            }
                          ]
                        }
                      ],
                      "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                    },
                    (v17/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "relationName"
                },
                (v17/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "issueLinkConnection(first:1)"
    }
  ],
  "type": "JiraIssueLinkField"
},
v89 = {
  "kind": "ScalarField",
  "name": "number"
},
v90 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraNumberFieldFormatConfig",
      "kind": "LinkedField",
      "name": "formatConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "formatStyle"
        },
        {
          "kind": "ScalarField",
          "name": "formatUnit"
        }
      ]
    }
  ]
},
v91 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isStoryPointField"
    },
    (v89/*: any*/),
    (v42/*: any*/),
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        (v89/*: any*/),
        (v90/*: any*/)
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        (v89/*: any*/),
        (v42/*: any*/),
        (v90/*: any*/),
        (v47/*: any*/)
      ]
    },
    (v47/*: any*/)
  ],
  "type": "JiraNumberField"
},
v92 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v42/*: any*/),
        {
          "concreteType": "JiraGroupConnection",
          "kind": "LinkedField",
          "name": "selectedGroupsConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraGroupEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v17/*: any*/),
                    (v42/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "groupId"
                    }
                  ]
                }
              ]
            }
          ]
        },
        (v47/*: any*/)
      ],
      "type": "JiraMultipleGroupPickerField"
    }
  ]
},
v93 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraFlag",
          "kind": "LinkedField",
          "name": "flag",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isFlagged"
            }
          ]
        }
      ],
      "type": "JiraFlagField"
    }
  ]
},
v94 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraWatch",
          "kind": "LinkedField",
          "name": "watch",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "count"
            },
            {
              "kind": "ScalarField",
              "name": "isWatching"
            }
          ]
        }
      ],
      "type": "JiraWatchesField"
    }
  ]
},
v95 = [
  {
    "concreteType": "JiraIssueFieldSetEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraIssueFieldSet",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v20/*: any*/),
          (v19/*: any*/),
          {
            "concreteType": "JiraIssueFieldConnection",
            "kind": "LinkedField",
            "name": "fields",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v22/*: any*/),
                      (v20/*: any*/),
                      (v41/*: any*/),
                      (v17/*: any*/),
                      (v43/*: any*/),
                      (v61/*: any*/),
                      (v62/*: any*/),
                      (v64/*: any*/),
                      (v66/*: any*/),
                      (v67/*: any*/),
                      (v68/*: any*/),
                      (v69/*: any*/),
                      (v53/*: any*/),
                      (v70/*: any*/),
                      (v71/*: any*/),
                      (v72/*: any*/),
                      (v73/*: any*/),
                      (v79/*: any*/),
                      (v80/*: any*/),
                      (v81/*: any*/),
                      (v82/*: any*/),
                      (v83/*: any*/),
                      (v84/*: any*/),
                      (v85/*: any*/),
                      (v86/*: any*/),
                      (v87/*: any*/),
                      (v88/*: any*/),
                      (v91/*: any*/),
                      (v92/*: any*/),
                      (v93/*: any*/),
                      (v94/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
],
v96 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "condition": "shouldQueryFieldSetsById",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "fieldSetIds",
              "variableName": "fieldSetIds"
            },
            (v18/*: any*/)
          ],
          "concreteType": "JiraIssueFieldSetConnection",
          "kind": "LinkedField",
          "name": "fieldSetsById",
          "plural": false,
          "selections": (v95/*: any*/)
        }
      ]
    },
    {
      "condition": "shouldQueryFieldSetsById",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "context",
              "variableName": "fieldSetsContext"
            },
            {
              "kind": "Variable",
              "name": "filterId",
              "variableName": "filterId"
            },
            (v18/*: any*/),
            {
              "kind": "Variable",
              "name": "namespace",
              "variableName": "namespace"
            },
            {
              "kind": "Variable",
              "name": "viewId",
              "variableName": "viewId"
            }
          ],
          "concreteType": "JiraIssueFieldSetConnection",
          "kind": "LinkedField",
          "name": "fieldSetsForIssueSearchView",
          "plural": false,
          "selections": (v95/*: any*/)
        }
      ]
    }
  ]
},
v97 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v98 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 500
        }
      ],
      "concreteType": "JiraIssueFieldSetConnection",
      "kind": "LinkedField",
      "name": "fieldSets",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueFieldSetEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueFieldSet",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v20/*: any*/),
                (v19/*: any*/),
                {
                  "concreteType": "JiraIssueFieldConnection",
                  "kind": "LinkedField",
                  "name": "fields",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraIssueFieldEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v16/*: any*/),
                            (v22/*: any*/),
                            (v20/*: any*/),
                            (v41/*: any*/),
                            (v17/*: any*/),
                            (v43/*: any*/),
                            (v61/*: any*/),
                            (v62/*: any*/),
                            (v64/*: any*/),
                            (v66/*: any*/),
                            (v67/*: any*/),
                            (v68/*: any*/),
                            (v69/*: any*/),
                            (v53/*: any*/),
                            (v70/*: any*/),
                            (v71/*: any*/),
                            (v72/*: any*/),
                            (v73/*: any*/),
                            (v79/*: any*/),
                            (v80/*: any*/),
                            (v81/*: any*/),
                            (v82/*: any*/),
                            (v83/*: any*/),
                            (v84/*: any*/),
                            (v85/*: any*/),
                            (v86/*: any*/),
                            (v87/*: any*/),
                            (v88/*: any*/),
                            (v91/*: any*/),
                            (v92/*: any*/),
                            (v93/*: any*/),
                            (v94/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraOptionConnection",
                                  "kind": "LinkedField",
                                  "name": "selectedOptions",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "concreteType": "JiraOptionEdge",
                                      "kind": "LinkedField",
                                      "name": "edges",
                                      "plural": true,
                                      "selections": [
                                        (v57/*: any*/),
                                        (v25/*: any*/)
                                      ]
                                    }
                                  ]
                                }
                              ],
                              "type": "JiraCheckboxesField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraOption",
                                  "kind": "LinkedField",
                                  "name": "fieldOption",
                                  "plural": false,
                                  "selections": [
                                    (v56/*: any*/),
                                    (v17/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraSingleSelectField"
                            },
                            (v25/*: any*/)
                          ]
                        }
                      ]
                    }
                  ]
                },
                (v25/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "fieldSets(first:500)"
    }
  ]
},
v99 = {
  "kind": "ScalarField",
  "name": "jql"
},
v100 = {
  "kind": "ScalarField",
  "name": "totalIssueSearchResultCount"
},
v101 = {
  "kind": "ScalarField",
  "name": "isCappingIssueSearchResult"
},
v102 = {
  "concreteType": "JiraIssueNavigatorPageInfo",
  "kind": "LinkedField",
  "name": "issueNavigatorPageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "firstIssuePosition"
    },
    {
      "kind": "ScalarField",
      "name": "lastIssuePosition"
    }
  ]
},
v103 = [
  (v97/*: any*/),
  {
    "kind": "ScalarField",
    "name": "pageNumber"
  },
  {
    "kind": "ScalarField",
    "name": "isCurrent"
  }
],
v104 = {
  "args": [
    {
      "kind": "Literal",
      "name": "maxCursors",
      "value": 7
    }
  ],
  "concreteType": "JiraPageCursors",
  "kind": "LinkedField",
  "name": "pageCursors",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "first",
      "plural": false,
      "selections": (v103/*: any*/)
    },
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "around",
      "plural": true,
      "selections": (v103/*: any*/)
    },
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "last",
      "plural": false,
      "selections": (v103/*: any*/)
    }
  ],
  "storageKey": "pageCursors(maxCursors:7)"
},
v105 = {
  "kind": "LinkedField",
  "name": "issueSearchError",
  "plural": false,
  "selections": [
    (v16/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ui_main_ConfigurableChildIssuesPanelQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_data"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v10/*: any*/),
      (v8/*: any*/),
      (v11/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v12/*: any*/),
      (v14/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v13/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v9/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchinm2performanceisissuesearchapienabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "ui_main_ConfigurableChildIssuesPanelQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              (v15/*: any*/),
              {
                "kind": "Variable",
                "name": "issueKey",
                "variableName": "issueKey"
              }
            ],
            "kind": "LinkedField",
            "name": "fieldSetViewQueryByProject",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v17/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "hasDefaultFieldSets"
                  },
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "fieldSetSelectedState": "SELECTED"
                        }
                      },
                      (v18/*: any*/)
                    ],
                    "concreteType": "JiraIssueSearchFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSets",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraIssueSearchFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "jqlTerm"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isSortable"
                              },
                              {
                                "concreteType": "JiraFieldSetPreferences",
                                "kind": "LinkedField",
                                "name": "fieldSetPreferences",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "width"
                                  }
                                ]
                              },
                              {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldsMetadata",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueSearchMetadataField",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "canBeConfigured"
                                              },
                                              (v22/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ClientExtension",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "isPlaceHolderField"
                                  }
                                ]
                              },
                              {
                                "concreteType": "JiraFieldType",
                                "kind": "LinkedField",
                                "name": "fieldType",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v23/*: any*/),
                      (v25/*: any*/)
                    ]
                  }
                ],
                "type": "JiraFieldSetView"
              },
              {
                "kind": "InlineFragment",
                "selections": (v26/*: any*/),
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v15/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "issueKey"
                  }
                ],
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issueByKey",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectField",
                    "kind": "LinkedField",
                    "name": "projectField",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": "editIssues",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "EDIT_ISSUES"
                                  }
                                ],
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": (v27/*: any*/),
                                "storageKey": "action(type:\"EDIT_ISSUES\")"
                              }
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": "createIssues",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_ISSUES"
                                  }
                                ],
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": (v27/*: any*/),
                                "storageKey": "action(type:\"CREATE_ISSUES\")"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "projectId"
                          },
                          (v28/*: any*/),
                          (v17/*: any*/)
                        ]
                      },
                      (v17/*: any*/)
                    ]
                  },
                  (v17/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchinm2performanceisissuesearchapienabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v31/*: any*/),
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issueSearch",
                "plural": false,
                "selections": [
                  (v23/*: any*/),
                  {
                    "concreteType": "JiraIssueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v28/*: any*/),
                          (v32/*: any*/),
                          (v17/*: any*/),
                          (v33/*: any*/),
                          (v37/*: any*/),
                          (v39/*: any*/),
                          (v16/*: any*/),
                          (v40/*: any*/),
                          (v96/*: any*/)
                        ]
                      },
                      (v16/*: any*/),
                      (v97/*: any*/),
                      (v25/*: any*/),
                      (v98/*: any*/)
                    ]
                  },
                  (v99/*: any*/),
                  (v100/*: any*/),
                  (v101/*: any*/),
                  (v102/*: any*/),
                  (v104/*: any*/),
                  (v105/*: any*/),
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "startCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasPreviousPage"
                      }
                    ]
                  },
                  (v25/*: any*/)
                ]
              },
              {
                "args": (v31/*: any*/),
                "filters": [
                  "issueSearchInput"
                ],
                "handle": "connection",
                "key": "ChildIssuesPanelIssueSearchPagination__issueSearch",
                "kind": "LinkedHandle",
                "name": "issueSearch"
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchinm2performanceisissuesearchapienabledrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": [
                  (v15/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/)
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issueSearchStable",
                "plural": false,
                "selections": [
                  (v23/*: any*/),
                  {
                    "concreteType": "JiraIssueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v28/*: any*/),
                          (v32/*: any*/),
                          (v17/*: any*/),
                          (v33/*: any*/),
                          (v37/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/),
                          (v96/*: any*/)
                        ]
                      },
                      (v16/*: any*/),
                      (v25/*: any*/),
                      (v98/*: any*/)
                    ]
                  },
                  (v99/*: any*/),
                  (v100/*: any*/),
                  (v101/*: any*/),
                  (v102/*: any*/),
                  (v104/*: any*/),
                  (v105/*: any*/),
                  (v25/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "7a5b7aaf2cc86caed2af30b08f381d8a6da83c2522a9ffa729475633a0c27306",
    "metadata": {},
    "name": "ui_main_ConfigurableChildIssuesPanelQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchinm2performanceisissuesearchapienabledrelayprovider": isIssueSearchAPIEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": isRealtimeUpdateEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider": isCheckIssueCreatePermissionsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": isJscInfiniteScrollEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": isJscM2Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": isMultiGroupPickerCellEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": isJscInlineEditFlagFixEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": isRenderJiraWatchesFieldNINEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider
    }
  }
};
})();

(node as any).hash = "86abc925f4aa0dd110f7904174e5850c";

export default node;
